import { render, staticRenderFns } from "./OpenModification.vue?vue&type=template&id=0bccd906&scoped=true&"
import script from "./OpenModification.vue?vue&type=script&lang=js&"
export * from "./OpenModification.vue?vue&type=script&lang=js&"
import style0 from "./OpenModification.vue?vue&type=style&index=0&id=0bccd906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bccd906",
  null
  
)

export default component.exports